import axios from 'axios';
import api from '../../../utils/api';

// In-flight deduplication: concurrent callers share one Promise.
// Completed cache: sequential callers skip re-fetching already-loaded data.
// Keys in use:
//   'banners:{type}'                                              — fetchAdvertisementBanners(type)
//   'eventBanners:{eventId}:{type}:is_active=true:show_all=true' — fetchEventBanners({ eventId, type })
const _pendingActions = {};
const _completedActions = {};

export default {
  async fetchAdvertisementBanners({}, type) {
    const key = `banners:${type}`;
    if (_completedActions[key]) return _completedActions[key];
    if (_pendingActions[key]) return _pendingActions[key];
    _pendingActions[key] = (async () => {
      try {
        const { data } = await axios(api.advertisement.fetchAdvertisementBanners(type));
        const results = data.results.sort((a, b) => a.position - b.position);
        _completedActions[key] = results;
        return results;
      } finally {
        delete _pendingActions[key];
      }
    })();
    return _pendingActions[key];
  },
  async fetchEventBanners({}, { eventId, type }) {
    const key = `eventBanners:${eventId}:${type}:is_active=true:show_all=true`;
    if (_completedActions[key]) return _completedActions[key];
    if (_pendingActions[key]) return _pendingActions[key];
    _pendingActions[key] = (async () => {
      try {
        const { data } = await axios(api.advertisement.fetchEventBanners(eventId, type));
        const result = data.results.sort((a, b) => a.position - b.position);
        _completedActions[key] = result;
        return result;
      } finally {
        delete _pendingActions[key];
      }
    })();
    return _pendingActions[key];
  },
  async fetchHomePagePopupBanner({ commit, rootGetters }) {
    const type = rootGetters.isMobileScreen ? 'homePagePopupMobile' : 'homePagePopup';
    const { data } = await axios(api.advertisement.fetchHomePagePopupBanner(type));
    const banner = data.results.length ? data.results[0] : null;
    commit('SET_HOME_PAGE_POPUP_BANNER', banner);
    return banner;
  },
};
